import React from 'react';
import {
  Card,
  CardImage,
  CardTitle,
  CardSubTitle,
} from 'styles/pages/news-room';

const NewsCard = () => (
  <Card
    onClick={() =>
      window.open(
        'https://res.cloudinary.com/big-oven-tees-inc/image/upload/v1645114521/Press_Release/Big_Oven_Tees_-_Counterfeit_Policing_and_IP_protection_Policy_-Final_uurbup.pdf'
      )
    }
  >
    <CardImage
      src="https://res.cloudinary.com/big-oven-tees-inc/image/upload/v1645114521/Press_Release/Big_Oven_Tees_-_Counterfeit_Policing_and_IP_protection_Policy_-Final_uurbup.png"
      alt="news-room"
    />
    <CardTitle>
      User Verification, Counterfeit Policing and IP Protecion Policy
    </CardTitle>
    <CardSubTitle>17/02/2022</CardSubTitle>
  </Card>
);

export default NewsCard;
